import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARKER, GRAY_LIGHT, NEAR_BLACK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export function ProcedureMethodEditorViewButton(props: {
  methodCid: string;
  onViewMethodEditor: (nodeId: string) => void;
}): React.JSX.Element {
  return (
    <BenchlingIcon
      className={css(styles.viewMethodEditorButton)}
      icon="eye"
      onClick={() => {
        props.onViewMethodEditor(props.methodCid);
      }}
    />
  );
}

const styles = StyleSheet.create({
  viewMethodEditorButton: {
    float: 'right',
    zIndex: 100,
    padding: '8px',
    width: '14px',
    height: '14px',
    borderRadius: 4,
    background: GRAY_LIGHT,
    color: GRAY_DARKER,
    ':hover': {
      color: NEAR_BLACK,
      cursor: 'pointer',
    },
  },
});
